const KEYS = {
    apiPath: process.env.REACT_APP_API_PATH,
    razorPayID: process.env.REACT_APP_RAZORPAY_ID,
    razorPaySecret: process.env.REACT_APP_RAZORPAY_SECRET,
    googleFontApiKey: process.env.REACT_APP_GOOGLE_FONT_API_KEY
}

export default KEYS;
